// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class CouponRedemptionFullRedemptionListFullRedemptionListResponse {
    static getAttributeTypeMap() {
        return CouponRedemptionFullRedemptionListFullRedemptionListResponse.attributeTypeMap;
    }
}
CouponRedemptionFullRedemptionListFullRedemptionListResponse.discriminator = undefined;
CouponRedemptionFullRedemptionListFullRedemptionListResponse.additionalProperties = false;
CouponRedemptionFullRedemptionListFullRedemptionListResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": "CardTcsWrapperModelsTcsRedemptionListRecordModel"
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=couponRedemptionFullRedemptionListFullRedemptionListResponse.js.map